import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'count',
  pure: true,
})
export class CountPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values: any[] | undefined,
  ): number | undefined {
    return this.statisticsExtractor.count(values);
  }

}
